module.exports = __webpack_public_path__ + "img/logo-animated.bc19378b.gif";